// const dayjs = require("dayjs");

import $ from "jquery";

if (window.CKEDITOR) CKEDITOR.disableAutoInline = true;
$(document).ready(function() {
    $.each($('.htmlEditor'), (i, el) => {
        initHtmlEditor(el);
    });

    $('form .submit').click(function(ev) {
        ev.preventDefault();
        $(this).parents('form').submit();
        return false;
    });
    $(document).on('click.bs.dropdown.data-api', '.keep-open', function(ev) {
        ev.stopPropagation();
    });
});

$(document).on('content-ready', function(ev, container) {
    container.find('.dropdown-textinput .dropdown-item').on('click', function(ev) {
        var me = $(this);
        var container = me.closest('.dropdown-textinput');
        container.find('input').val(me.html());
    });

    container.find('.select-dropdown .dropdown-item').on('click', function(ev) {
        var me = $(this);
        me.closest('.dropdown-menu').find('.active').removeClass('active');
        me.addClass('active');
        var dropdown = me.closest('.select-dropdown');
        if (dropdown.is('[data-control-name]')) {
            $('[name="'+dropdown.attr('data-control-name')+'"]').val(me.attr('data-value') || me.html());
        }
    });
    container.find('.select-dropdown').on('hide.bs.dropdown', function(ev) {
        var me = $(this);
        var selected = me.find('.active').not('.inactive');
        $(ev.relatedTarget).html(selected.attr('data-display') || selected.html());
    });
    container.find('.select-dropdown[data-list]').on('show.bs.dropdown', function(ev) {
        var me = $(this);
        var meMenu = me.find('.dropdown-menu');
        // Add items if not there
        if (meMenu.find('.dropdown-item').length === 0) {
            var menu = $(me.attr('data-list'));
            menu.find('.dropdown-item').clone().appendTo(meMenu);
            me.find('.dropdown-item').on('click', function (ev) {
                $(this).closest('.dropdown-menu').find('.active').removeClass('active');
                $(this).addClass('active');
                me.attr('data-selected', $(this).attr('data-value'));
            });
        }
        if (me.is('[data-selected]')) {
            meMenu.find('[data-value="'+me.attr('data-selected')+'"]').addClass('active');
        }
        meMenu.data('this', meMenu);
    });
    container.find('.select-dropdown[data-list]').on('shown.bs.dropdown', function(ev) {
        var me = $(this);
        if (me.is('[data-filterable]')) {
            var meMenu = me.find('.dropdown-menu');
            var filterEl = me.find('[data-filter]');
            var items = meMenu.find('[data-search]');
            filterEl.val("");
            filterEl.keyup(function() {
                var query = filterEl.val().toLowerCase();
                $.each(items, function() {
                    var item = $(this);
                    if (item.attr('data-search').indexOf(query) === -1) {
                        item.hide();
                    } else {
                        item.show();
                    }
                });
            });
            meMenu.width(meMenu.width());
            filterEl.focus();
        }
    });

    container.find('.dropdown-select').each(function() {
        var el = $(this);
        initDropdownSelectItems(el);
    });

    container.find('.form-colorpicker').each(function() {
        var el = $(this);
        el.colorpicker();
    });

    container.find('.palette-editor').each(function() {
        var el = $(this);
        var colorPickerEl = el.find('.dropdown-colorpicker');
        var paletteList = el.find('.colorpicker-swatches--inner');
        colorPickerEl.on('changed', (ev, data) => {
            var newEl = $(`<i class="colorpicker-swatch" data-value="${data.color}"><i class="colorpicker-swatch--inner" style="background-color: ${data.color};"></i></i>`);
            paletteList.append(newEl);
            colorPickerEl.colorpicker('setValue', '');
            updateColors();

            newEl.click((ev) => {
                $(ev.currentTarget).remove();
                updateColors();
            });
        });
        paletteList.find('.colorpicker-swatch').click((ev) => {
            $(ev.currentTarget).remove();
            updateColors();
        });
        paletteList.sortable({
            stop: ev => {
                updateColors();
            },
        });
        function updateColors() {
            var colors = paletteList.find('[data-value]')
                .map((i, el) => $(el).attr('data-value'))
                .toArray()
                .join(",");
            el.find('[data-setting]')
                .val(colors)
                .trigger('change');
        }
    });

    container.find('[data-plzsync]').blur(function() {
        var plzInput = $(this);
        var targetField = $(plzInput.attr('data-plzsync'));
        searchPlzInfo(plzInput, targetField);
    });

    container.find('[data-role-toggler]').on('change', (ev) => {
        var me = $(ev.currentTarget);
        var roleData = me.attr('data-role-toggler').split(":");
        connection.getJson('/User/ToggleUserRole', {
            data: { id: roleData[0], roleId: roleData[1] }
        });
    });

    // Input help-texts
    container.find('.input-group[data-helptarget]').each(function() {
        var me = $(this);
        var targetEl = $(me.attr('data-helptarget'));
        me.find('input').focus(function() {
            targetEl.collapse('show');
        });
        me.find('input').blur(function() {
            targetEl.collapse('hide');
        });
    });

    if ($.fn.ionRangeSlider) {
        container.find(".ion-range").ionRangeSlider({
            onFinish: function (data) {
                $(data.input).trigger("onChanged", [data]);
            },
            onChange: function (data) {
                $(data.input).trigger("onChange", [data]);
            }
        });
    }
    if (window.dropzone) {
        dropzone.init(container);
    }
    registerDragables(container);
    registerDatePickers(container.find('.ctl-datepicker'));
    initSlideinButtons(container.find('[data-slidein],[data-static-slidein]'));
    initCheckboxes(container.find('input[type=checkbox][data-action]'));
    initCheckboxAllOnOff($('body'));
    initExpanders(container.find('.expandable'));
    initBootstrapSelect(container.find('.selectpicker'));
    initColorpicker(container.find('.dropdown-colorpicker'));
    initMentions(container.find('.ctl-mention-container'));
    loadMaps(container);
});

function initMaps() {
    loadMaps($('body'));
}
window.initMaps = initMaps;

document.addEventListener('cookiebundle-on-accept-or-change', function (event) {
    if (event.detail?.categories?.includes('maps')) {
        loadMaps($('body'));
    }
});

function loadMaps(container) {
    container.find('.googlemap-display').not('.inited').each(function() {
        var gmap = $(this);
        if (gmap.is('.inited')) return;

        if (typeof window.google == 'undefined') {
            gmap.append('<div style="line-height:60px;text-align:center;" class="bg-light"><a href="javascript:showCookieWindow()">Cookies akzeptieren</a>, um die Google Karte zu sehen.</div>');
        } else {
            gmap.addClass('inited');
            console.log('load gmap', gmap);
            var myPosition = new google.maps.LatLng(parseFloat(gmap.attr('data-lat')), parseFloat(gmap.attr('data-lng')));
            var mapOptions = {
                scrollwheel: false,
                zoom: parseInt(gmap.attr('data-zoom') || 12),
                center: myPosition,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map(gmap[0], mapOptions);
            var marker = new google.maps.Marker({
                position: myPosition,
                map: map,
                draggable: false
            });
        }
    });
}

function getCkMentionConfig(items) {
    return {
        feeds: [{
            marker: '@',
            feed: (queryText) => {
                return new Promise(resolve => {
                    const searchString = queryText.toLowerCase();
                    setTimeout( () => {
                        const itemsToDisplay = items
                            .filter(item => {
                                return (
                                    item.name.toLowerCase().includes( searchString ) ||
                                    item.id.toLowerCase().includes( searchString )
                                );
                            })
                            .slice(0, 10);

                        resolve(itemsToDisplay);
                    }, 100);
                });
            },
            itemRenderer: (item) => {
                // <button class="ck ck-button ck-off ck-button_with-text" type="button" tabindex="-1" aria-labelledby="ck-editor__aria-label_e021c3f479cabacf406985dd6226f97b3" data-cke-tooltip-position="s">
                //   <span class="ck ck-button__label" id="ck-editor__aria-label_e021c3f479cabacf406985dd6226f97b3">@Lukas Schnieper</span>
                // </button>
                const itemElement = document.createElement('button');
                itemElement.classList.add('ck', 'ck-button', 'ck-button_with-text');

                const textElement = document.createElement( 'span' );
                textElement.classList.add('ck', 'ck-button__label');
                textElement.textContent = `${item.name} (${item.email})`;
                itemElement.appendChild(textElement);

                return itemElement;
            },
        }]
    };
}

function getCkGetMentionList(el) {
    var mentionItems = [];
    var mentionContainerEl = $(el).closest('.ctl-mention-container');
    $.each(mentionContainerEl.find('[data-mention-list] input[type=checkbox]'), function() {
        if ($(this).attr('data-email')) {
            mentionItems.push({
                id: '@' + $(this).attr('data-text'),
                email: $(this).attr('data-email'),
                name: $(this).attr('data-text'),
            });
        }
    });
    return mentionItems;
}

function initHtmlEditor(el, onInited) {
    if (window.CkClassicEditor) {
        var mentionItems = getCkGetMentionList(el);
        window.CkClassicEditor
            .create(el, {
                toolbar: {
                    items: [
                        'undo', 'redo', '|',
                        'bold', 'italic', 'underline', 'line', 'strikethrough', 'subscript', 'superscript', 'link', 'bulletedList', 'numberedList',
                        'todoList', 'insertTable', 'horizontalLine', '-',
                        'emoji', 'fontSize', 'fontColor', 'fontBackgroundColor', 'removeFormat', '|',
                        'sourceEditing'
                    ],
                    shouldNotGroupWhenFull: true
                },
                mention: getCkMentionConfig(mentionItems),
                table: {
                    contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
            })
            .then((editor) => {
                $(el).data('editorInst', editor);
                if (onInited) onInited(editor);
            })
            .catch(error => {
                console.error(error);
            });
    }
}
window.initHtmlEditor = initHtmlEditor;

function initHtmlMiniEditor(el, onInited) {
    if (window.CkClassicEditor) {
        var mentionItems = getCkGetMentionList(el);
        window.CkClassicEditor
            .create(el, {
                toolbar: {
                    items: [
                        'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript',
                        'fontColor', 'fontBackgroundColor', 'removeFormat', 'emoji'
                    ],
                    shouldNotGroupWhenFull: true
                },
                mention: getCkMentionConfig(mentionItems),
            })
            .then((editor) => {
                $(el).data('editorInst', editor);
                if (onInited) onInited(editor);
            })
            .catch(error => {
                console.error(error);
            });
    }
}
window.initHtmlMiniEditor = initHtmlMiniEditor;

function initDropdownSelectItems(dropdownSelectEl) {
    var inputEl = dropdownSelectEl.find('input');
    var displayEl = dropdownSelectEl.find('input.form-display');
    dropdownSelectEl.find('.dropdown-item').not('.disabled').click(function() {
        dropdownSelectEl.find('.dropdown-item.bg-light').removeClass('bg-light');
        dropdownSelectEl.find('.dropdown-item.active').removeClass('active');
        $(this).addClass('bg-light active');
        inputEl.val($(this).attr('data-value') || $(this).text());
        inputEl.trigger('changed');
        if (displayEl.length) {
            displayEl.val($(this).attr('data-display'));
        }
    });
    inputEl.on('changed', function() {
        var el = inputEl.closest('.dropdown-select').find('[data-value="'+inputEl.val()+'"]');
        displayEl.val(el.attr('data-display'));
    });
}

window.initDropdownSelectItems = initDropdownSelectItems;

function searchPlzInfo(plzField, targetField, onComplete) {
    var plz = plzField.val();
    if(plz.length === 4){
        targetField.inputRunning();
        var apiHref = 'https://api3.geo.admin.ch/rest/services/api/MapServer/find?layer=ch.swisstopo-vd.ortschaftenverzeichnis_plz&searchText=' + plz +'&searchField=plz&limit=1&returnGeometry=false';
        connection.getJson(apiHref, {
            onComplete: function(){
                targetField.inputEndRunning();
            },
            onSuccess: function (data) {
                if(data.results.length > 0){
                    var attrs = data.results["0"].attributes;
                    targetField.val(attrs.langtext);
                    if (plzField.is('[data-kantonsync]')) {
                        $(plzField.attr('data-kantonsync')).val(attrs.gdekt);
                    }
                    if (plzField.is('[data-landsync]')) {
                        $(plzField.attr('data-landsync')).val('Schweiz');
                    }
                    if (onComplete) onComplete(attrs);
                }
            },
            onError: function() {
                // prevent error message
            },
        });
    }
}
window.searchPlzInfo = searchPlzInfo;

function registerDragables(container) {
    $.each(container.find('[data-dragsort]'), function() {
        var sortContainer = $(this);
        sortContainer.sortable({
            helper: "clone",
            appendTo: $('body'),
        });
    });

    $.each(container.find('[data-dragdrop]'), function() {
        var me = $(this);
        container.find('.drag-handle').draggable({
            helper: "clone",
            appendTo: $('body')
        });
        container.find(me.attr('data-drop-targets')).droppable({
            accept: ".drag-handle",
            over: function(event, ui) {
                $(this).addClass('drag-over');
            },
            out: function(event, ui) {
                $(this).removeClass('drag-over');
            },
            drop: function(event, ui) {
                var droppable = $(this);
                droppable.removeClass('drag-over');
                if (droppable.attr('data-drop-ajax')) {
                    params = {};
                    droppable.startProcess();
                    try {
                        var params = JSON.parse(ui.draggable.attr('data-drop-params').replace(/'/g, '\"'));
                    } catch (e) {}
                    connection.getJson(droppable.attr('data-drop-ajax'), {
                        data: params,
                        onSuccess: function() {
                            droppable.prepend(ui.draggable);
                            messaging.showGlobalMessage('success', null, 'Die Investitionsprognose wurde verschoben.');
                        },
                        onComplete: function() {
                            droppable.endProcess();
                        },
                        onError: function() {
                            debugger;
                        }
                    });
                }
            }
        });
    });
}

window.registerDragables = registerDragables;

function registerDatePickerCbo(container) {
    var pickers = container.find('[data-dp-container]');
    $.each(pickers, function(index, el) {
        var container = $(el);
        var ctlDay = container.find('[data-dp-cbo="day"]');
        var ctlMonth = container.find('[data-dp-cbo="month"]');
        var ctlYear = container.find('[data-dp-cbo="year"]');

        ctlMonth.selectpicker({
            liveSearch: true,
            liveSearchPlaceholder: 'Monat'
        });
        ctlDay.selectpicker({
            width: 80,
            liveSearch: true,
            liveSearchPlaceholder: 'Tag'
        });
        ctlYear.selectpicker({
            liveSearch: true,
            liveSearchPlaceholder: 'Jahr'
        });

        var target = container.find('input');
        container.find('[data-dp-cbo]').change(function() {
            var dateValue = dayjs(ctlYear.val()+"-"+ctlMonth.val()+"-"+ctlDay.val());
            if (dateValue.format('YYYY-MM-DD') !== "Invalid date") {
                target.val(dateValue.format('YYYY-MM-DD'));
            } else {
                target.val('');
            }
        });

        ctlDay.on('shown.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            var dayMenu = ctlDay.parent().find('ul.dropdown-menu');
            var dateValue = dayjs(ctlYear.val()+"-"+ctlMonth.val()+"-01");
            var daysInMonth = dateValue.daysInMonth();
            dayMenu.find('li').show();
            dayMenu.find('li').filter(function(i, el) {
                return (i + 1) > daysInMonth;
            }).hide();
            if (dayMenu.find('li.selected').is(':hidden')) {
                $(ctlDay).selectpicker('val', '1');
            }
        });

        ctlMonth.change(function() {
            var dateValue = dayjs(ctlYear.val()+"-"+ctlMonth.val()+"-01");
            var daysInMonth = dateValue.daysInMonth();
            if (parseInt(ctlDay.val()) > daysInMonth) {
                $(ctlDay).selectpicker('val', daysInMonth);
            }
        }).change();
    });
}

window.registerDatePickerCbo = registerDatePickerCbo;

function registerDatePickers(pickers, options) {
    if (!pickers.datepicker) {
        alert("datepicker not available!");
        return;
    }

    $.each(pickers, function(index, el) {
        var field = $(el);
        if (field.parent().is('.datepicker-container')) return;
        //
        field.wrap('<div class="input-group datepicker-container"></div>');
        var displayEl = field.clone();
        displayEl.attr('id', displayEl.attr('id')+'display'+Math.ceil(Math.random() * 200))
            .attr('name', '');
        field.addClass('d-none').before(displayEl);
        $('<div class="input-group-append linkify"><span class="input-group-text bg-white"><i class="fa bi-calendar-fill"></i></span></div>').insertAfter(field);
        if (field.val()) {
            var startValue = dayjs(field.val());
            displayEl.val(startValue.format('DD.MM.YYYY'));
        }
        field.parent().find('.input-group-append').click(function() {
            displayEl.datepicker('show');
        });
        var todayBtn = true;
        if (field.attr('data-todayBtn')) {
            if (field.attr('data-todayBtn') === 'linked') {
                todayBtn = 'linked';
            } else {
                todayBtn = field.attr('data-todayBtn') === 'true';
            }
        }
        displayEl.datepicker({
            language: 'de',
            format: 'dd.mm.yyyy',
            todayBtn: todayBtn,
            todayHighlight: true,
            firstDay: 1,
            autoclose: true,
        }).on('changeDate, hide', function(e) {
            field.val(e.format('yyyy-mm-dd')).trigger('blur', {ev: e});
        });
    });
}

window.registerDatePickers = registerDatePickers;

function initSlideinButtons(elements) {
    elements.off('click').click(function(ev) {
        var me = $(this);
        if (me.is('[data-slidein]')) {
            slidein.openUrl(me.attr('data-slidein'), function (element) {
            }, {
                linkEl: me,
                timeout: me.attr('data-timeout'),
                overlay: me.is('[data-overlay]'),
                backbutton: me.attr('data-back'),
            });
        } else if (me.is('[data-static-slidein]')) {
            slidein.openUrl('', function() {
            }, {
                contentElement: $(me.attr('data-static-slidein')),
            });
        }
        if (me.is('[data-return]')) {
            return me.attr('data-return') === "true";
        }
        return false;
    });
}

window.initSlideinButtons = initSlideinButtons;

function initExpanders(elements) {
    $.each(elements, function() {
        var me = $(this);
        var area = me.find('.expander');
        if (area.find('>').height() > me.height()) {
            me.addClass('isbigger');
            me.find('>svg').off('click').on('click', function() {
                var height = area.find('>').height();
                if (me.hasClass('opened')) {
                    area.animate({
                        height: area.data('height')
                    });
                    me.removeClass('opened');
                } else {
                    area.animate({
                        height: height
                    });
                    me.addClass('opened');
                }
            });
        }
    });
}

window.initExpanders = initExpanders;

function initBootstrapSelect(elements) {
    $.each(elements, function() {
        var me = $(this);
        me.selectpicker({
            liveSearchPlaceholder: 'filtern ...'
        });
    });
}

window.initBootstrapSelect = initBootstrapSelect;

function initCheckboxes(elements, options) {
    options = options || {};
    var attribute = options.attribute || 'data-action';
    elements.click(function() {
        var me = $(this);
        if (!me.is('['+attribute+']')) return;

        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: me.attr(attribute),
                    type: 'get',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    data: {
                        add: me.is(':checked')
                    },
                    success: function(data) {
                        if (data.checked == true) {
                            messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
                        } else if (data.checked == false) {
                            messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
                        } else {
                            messaging.showPermanentGlobalMessage('danger', null, 'Fehler beim speichern!');
                        }
                        if (options.onSuccess != null) options.onSuccess(data, me);
                    },
                    error: function(data) {
                        if (data.responseJSON && data.responseJSON.checked) {
                            me.prop('checked', data.responseJSON.checked ? 'checked' : null);
                        }
                        if (data.statusText == 'timeout' && onTaskError) {
                            onTaskError(null, true);
                            return;
                        }
                        if (onTaskError) onTaskError(connection.getErrorMessageOf(data, 'Speichern fehlgeschlagen'), false, function() {
                            if (options.onError) {
                                options.onError(data.responseJSON, data);
                            }
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    });
}

function initInlineSearch(container) {
    $.each(container.find('[data-inline-search]'), function() {
        var me =$(this);
        var inputEl = me.find('input');
        var clearBtn = me.find('[data-search-reset]');
        var execBtn = me.find('[data-search-exec]');

        var searchItems = $(me.attr('data-inline-search'));
        inputEl.on('keyup', function(ev) {
            var query = $(this).val().toLowerCase();
            $.each(searchItems, function() {
                $(this).toggleClassIf('d-none', $(this).attr('data-search').indexOf(query) === -1);
            })
        });
        clearBtn.click(function() {
            inputEl.val('').trigger('keyup');
        });
        execBtn.click(function() {
            inputEl.trigger('keyup');
        });
    });
}
window.initInlineSearch = initInlineSearch;

function initCheckboxAllOnOff(container) {
    container.find('[data-allon]').click(function() {
        var me = $(this);
        $.each(container.find('.'+me.attr('data-allon')+' .form-check-label input'), function(i, el) {
            if (!$(el).is(':checked')) {
                $(el).trigger('click');
            }
        });
    });
    container.find('[data-alloff]').click(function() {
        var me = $(this);
        $.each(container.find('.'+me.attr('data-alloff')+' .form-check-label input'), function(i, el) {
            if ($(el).is(':checked')) {
                $(el).trigger('click');
            }
        });
    });
}

function initMentions(els) {
    $.each(els, function () {
        var mentionContainerEl = $(this);
        var mentionEl = mentionContainerEl.find('.ctl-mention');
        mentionEl.suggest('@', {
            position: 'bottom',
            data: function(q, provide) {
                var data = [];
                $.each(mentionContainerEl.find('[data-mention-list] input[type=checkbox]'), function() {
                    if ($(this).attr('data-email')) {
                        data.push({value: $(this).attr('data-email'), text: $(this).attr('data-text')});
                    }
                });
                provide(data);
            },
        });
        var hasMentionsList = mentionContainerEl.find('[data-mention-list]').length > 0;
        if (hasMentionsList) {
            mentionContainerEl.find('[data-mention-list] input[type=checkbox]').change(function() {
                syncMentions(mentionContainerEl);
            });
        }
        if (mentionContainerEl.find('.mentions-list').length > 0) {
            mentionEl.on('suggest.select suggest.deleted', function (ev, item) {
                console.log("mention changed");
                mentionContainerEl.find('[data-email="'+item.value+'"]').prop('checked', 'checked');
                syncMentions(mentionContainerEl);
            });
        }
        mentionContainerEl.find('[data-add-mention]').click(function() {
        });
        mentionContainerEl.find('#MentionAllShares').change(function(ev) {
            var isChecked = $(ev.target).is(':checked');
            mentionContainerEl.find('input[data-type="share"]')
                .prop('checked', isChecked ? 'checked' : null);
            syncMentions(mentionContainerEl);
        });
    });
}

function syncMentions(mentionContainerEl) {
    var list = [];
    var selected = mentionContainerEl.find('[data-mention-list] input[type=checkbox][data-email]:checked');
    $.each(selected, function () {
        var item = '@' + $(this).parent().find('label').text().trim();
        if (list.indexOf(item) === -1) {
            list.push(item);
        }
    });
    mentionContainerEl.find('.mentions-list').html(list.join(", ") + '&nbsp;');
    mentionContainerEl.find('.mentions-count').html(list.length > 0 ? `&nbsp;(${list.length})` : '');
}
window.syncMentions = syncMentions;

function initColorpicker(colorPickerEls, options) {
    $.each(colorPickerEls, function () {
        var colorPickerEl = $(this);

        if (!colorPickerEl.is('[data-inline]')) {
            colorPickerEl.click(function () {
                colorPickerEl.colorpicker('toggle');
            });
        }
        var pickerOptions = {
            format: 'hex',
            template: '<div class="colorpicker">' +
                '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
                '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
                '<div class="colorpicker-alpha">' +
                '   <div class="colorpicker-alpha-color"></div>' +
                '   <i class="colorpicker-guide"></i>' +
                '</div>' +
                '<div class="d-flex w-100">' +
                '  <div contenteditable="true" class="form-control"></div>' +
                '</div>' +
                '<div class="d-flex mt-2 btn-group">' +
                '  <a href="#" data-cancel class="btn btn-light d-flex align-items-center">Abbrechen</a>' +
                '  <a href="#" data-ok class="btn btn-success d-flex align-items-center">OK</a>' +
                '</div>' +
                '</div>'
        };
        if (options) pickerOptions = $.extend(pickerOptions, options);

        colorPickerEl.colorpicker(pickerOptions);
        if (colorPickerEl.attr('data-target')) {
            $(colorPickerEl.attr('data-target')).val(colorPickerEl.attr('data-color'));
        }
        colorPickerEl.on('colorpickerChange', function (event) {
            var me = $('.colorpicker.colorpicker-visible');
            var inputEl = colorPickerEl;
            var color = event.color ? event.color.toString().toUpperCase() : null;
            me.find('[contenteditable]').html(color);
            me.find('.colorpicker-swatches [data-value]').removeClass('active');
            if (event.value === 'cx' || event.color === null) {
                inputEl.find('.picker-color').attr('data-new', '');
                inputEl.find('.picker-color').css('background', '');
                // colorPickerEl.attr('data-color', '');
                me.find('.colorpicker-swatches [data-value=""]').addClass('active');
            } else {
                inputEl.find('.picker-color').attr('data-new', event.color.toString());
                inputEl.find('.picker-color').css('background', event.color.toString());
                // colorPickerEl.attr('data-color', event.color.toString());
                me.find('.colorpicker-swatches [data-value="' + event.color.toString().toLowerCase() + '"]').addClass('active');
            }
        });
        colorPickerEl.on('colorpickerShow', function (event) {
            var popoverContainer = $('.colorpicker-bs-popover.show');
            initColorPickerOnShow(colorPickerEl, popoverContainer, event.color.toString());
        });
        colorPickerEl.on('colorpickerHide', function (event) {
            var resetColor = colorPickerEl.attr('data-color');
            colorPickerEl.find('.picker-color').css('background', resetColor);
            colorPickerEl.colorpicker('setValue', resetColor);
        });
    });
}

function initColorPickerOnShow(colorPickerEl, popoverContainer, hexColor) {
    // add swatches
    if (colorPickerEl.attr('data-colors')) {
        var swatches = popoverContainer.find('.colorpicker-swatches');
        if (swatches.length === 0) {
            var moreColorsButton = $(`<span class="btn btn-sm btn-default btn-add-color">Andere Farbe</span>`);
            popoverContainer.find('.colorpicker').prepend(moreColorsButton);
            popoverContainer.find('.colorpicker>.colorpicker-saturation,.colorpicker>.colorpicker-hue,.colorpicker>.colorpicker-alpha,.colorpicker>.d-flex').wrapAll('<div class="new-color d-none pt-2"></div>');
            moreColorsButton.click(ev => {
                popoverContainer.find('.new-color').toggleClass('d-none');
                popoverContainer.find('.colorpicker-swatches').toggleClass('d-none');
                moreColorsButton.text(popoverContainer.find('.new-color').is(':visible') ? 'Farb-Paletten' : 'Andere Farbe');
            });

            swatches = $(`<div class="colorpicker-bar colorpicker-swatches show-swatches text-left my-0"></div>`);
            popoverContainer.find('.colorpicker').prepend(swatches);
        } else {
            swatches.empty();
        }

        swatches.append('<div class="d-flex justify-content-end text-info">' +
            '  <div class="hoverable">' +
            '    <div class="hover-visible tooltip-box">Benutzerdefinierte Farben können in den <a href="#">Firmen-Einstellungen</a> hinzugefügt werden.</div>' +
            '    <i class="fa bi-question-circle"></i>' +
            '  </div>' +
            '</div>');

        swatches.find('.tooltip-box').click(() => {
            location.href = '/Planner/Profil/Settings#nav-settings';
        });

        var colors = gantt_api.getColorPalette();
        $.each(colors, (i, list) => {
            if (list.colors.length > 0) {
                var colorList = $(`<div class="default-colors"><strong>${list.label}</strong><div class="colorpicker-swatches--inner"></div></div>`);
                $.each(list.colors, (i, c) => {
                    var colorItem = $(`<i class="colorpicker-swatch" data-value="${c.toUpperCase()}" title="${c}"><i class="colorpicker-swatch--inner" style="background-color: ${c.toUpperCase()};"></i></i>`);
                    colorList.find('.colorpicker-swatches--inner').append(colorItem);
                });
                swatches.append(colorList);
            }
        });
    }

    popoverContainer.find('[contenteditable]').html((hexColor || '').toUpperCase());
    popoverContainer.find('.colorpicker-swatches [data-value="' + (hexColor || '').toUpperCase() + '"]').addClass('active');
    popoverContainer.find('.colorpicker-swatches .colorpicker-swatch').off('click').click(function(ev) {
        var color = $(this).attr('data-value');
        colorPickerEl.colorpicker('setValue', color);
        saveColorPickerValue(colorPickerEl, color);
    });
    popoverContainer.find('[data-ok]').off('click').click(function (ev) {
        var color = colorPickerEl.colorpicker('getValue');
        saveColorPickerValue(colorPickerEl, color);
        return false;
    });
    popoverContainer.find('[data-cancel]').off('click').click(function (ev) {
        if (!colorPickerEl.is('[data-inline]')) {
            colorPickerEl.colorpicker('colorpicker').popupHandler.clicking = false;
            colorPickerEl.colorpicker('hide', {currentTarget: document, target: document});
        }

        colorPickerEl.trigger('canceled', { });
        return false;
    });

    var pickerInputEl = popoverContainer.find('[contenteditable]');
    pickerInputEl.off('keyup change').on('keyup change', (ev) => {
        var inputStr = pickerInputEl.text();
        var str = inputStr.toLowerCase().trim();
        var isHex = !!str.match(/^#?[0-9a-f]{6}$/i);
        if (isHex) {
            colorPickerEl.colorpicker('setValue', str);
        }
        if (pickerInputEl.html() !== pickerInputEl.text()) {
            pickerInputEl.text(str);
        }
        var isHexLike = !!str.match(/^#?[0-9a-f]{0,6}$/i);
        pickerInputEl.toggleClass('is-invalid', !isHexLike);
    });
}

function saveColorPickerValue(colorPickerEl, color) {
    setTimeout(function () {
        var hasNewAttr = typeof colorPickerEl.find('.picker-color').attr('data-new') !== "undefined";
        if (hasNewAttr && colorPickerEl.find('.picker-color').attr('data-new') !== colorPickerEl.attr('data-color')) {
            colorPickerEl.attr('data-color', color.toString());
            colorPickerEl.find('.picker-color').css('background', color.toString());
            if (colorPickerEl.attr('data-target')) {
                $(colorPickerEl.attr('data-target')).val(color.toString()).trigger('change');
            }
            if (colorPickerEl.attr('data-save')) {
                connection.getJson(colorPickerEl.attr('data-save'), {
                    data: {
                        addressId: colorPickerEl.closest('[data-owner]').attr('data-owner'),
                        options: JSON.stringify({'Color': color.toString()}),
                    },
                    onSuccess: function (data) {
                        colorPickerEl.trigger('changed', { id: colorPickerEl.attr('data-id'), color: color });
                    }
                });
            } else {
                colorPickerEl.trigger('changed', { id: colorPickerEl.attr('data-id'), color: color });
            }
        } else {
            colorPickerEl.trigger('changed', { color: color });
        }

        if (!colorPickerEl.is('[data-inline]')) {
            colorPickerEl.colorpicker('colorpicker').popupHandler.clicking = false;
            colorPickerEl.colorpicker('hide', {currentTarget: document, target: document});
        }
    }, 10);
}

window.initColorpicker = initColorpicker;
window.initColorPickerOnShow = initColorPickerOnShow;
window.saveColorPickerValue = saveColorPickerValue;
